// ATL Tour Frontend
;(function(w){
	function initRelatedToursSlider() {
		var $ = w.jQuery;

		if (!$ || !$.fn || !$.fn.owlCarousel) {
			setTimeout(initRelatedToursSlider, 100);
			return;
		}

		var $slider = $('.related-project-slider');
		if (!$slider.length) {
			return;
		}

		$slider.owlCarousel({
			loop: true,
			margin: 30,
			nav: false,
			dots: false,
			autoWidth: false,
			autoplay: true,
			slideTransition: 'linear',
			autoplayTimeout: 5000,
			autoplaySpeed: 5000,
			responsive: {
				0: { items: 1 },
				768: { items: 2 },
				1024: { items: 3 }
			},
			navText: ['<i class="bi bi-arrow-left"></i>', '<i class="bi bi-arrow-right"></i>']
		});
	}

	function initWhenReady() {
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', initRelatedToursSlider);
		} else {
			initRelatedToursSlider();
		}
	}

	initWhenReady();
})(window);
